import * as React from 'react';

import {Button} from 'shells/button/button';
import {Stack} from 'shells/layout/stack/stack';

import {handleCall} from '../../../../phone/handle-call';

import {CellStringsTokenized} from './relationship/strings-tokenized';
import {CellString} from './string';
import type {Phone} from './types';

type Props = {
    entityId: string;
    value: Phone[];
};

export function CellPhones(props: Props) {
    const phoneCallerTypeValue =
        typeof NutshellFrontendSettings !== 'undefined' && NutshellFrontendSettings.phonecaller_type
            ? NutshellFrontendSettings.phonecaller_type
            : '';

    if (props.value.length === 0) {
        return null;
    }

    return (
        <>
            {phoneCallerTypeValue ? (
                <Stack spacing={0}>
                    {props.value.map((phone: Phone) => {
                        const id = `${props.entityId}-${phone.value.valueRaw || phone.value.value}`;

                        if (!phone.value.valueRaw) {
                            return <CellString value={phone.value.value} type='phone' />;
                        }

                        return (
                            <Button
                                key={id}
                                id={id}
                                variant='text-primary'
                                size='small'
                                onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();

                                    handleCall(
                                        phone.value.value,
                                        phone.value.valueRaw,
                                        phoneCallerTypeValue,
                                        props.entityId,
                                        id
                                    );
                                }}
                                noPadding={true}
                            >
                                {phone.value.value}
                            </Button>
                        );
                    })}
                </Stack>
            ) : (
                <CellStringsTokenized
                    value={props.value.map((phone) => ({value: {value: phone.value.value}}))}
                />
            )}
        </>
    );
}
